class CartItems extends HTMLElement {
  constructor() {
    super();

    this.cartCountDown = document.getElementById(
      `CartCountdown-${this.dataset.section}`
    );
    this.giftCardElement = document.getElementById("is-a-gift");
    this.giftCardButton = document.getElementById("cart-gift-wrapping");
    this.toCheckoutButton = document.getElementById("cart-checkout");
    this.couponCodeInput = document.getElementById("cart-coupon-code");
    this.cartNoteInput = document.getElementById("cart-note");
    this.checkTerms = document.getElementById("cart_conditions");
    this.isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    // Initialize core functionality
    this.initToCheckoutButtonDisabling();
    this.initCartCountdown();
    if (this.giftCardElement) this.initGiftCardElement();
    this.initGiftCardManipulation();

    // Set up a one-time initialization after a short delay
    // This helps ensure DOM is fully loaded and third-party scripts have initialized
    setTimeout(() => {
      this.initCartFunctionality();
    }, 500);

    // Also set up a periodic refresh of event listeners
    // This helps with iOS and third-party script interactions
    this.refreshInterval = setInterval(() => {
      this.refreshEventListeners();
    }, 2000);
  }

  // Initialize cart functionality once
  initCartFunctionality() {
    // Find all cart item elements and selectors
    this.cartItemRows = this.querySelectorAll("[data-item-row]");
    this.cartContent = this.querySelector("[data-cart-content]");

    // Set up iPad/iPhone-specific CSS
    if (this.isIOS) {
      this.setupIOSSpecificStyles();
    }

    // Initialize event listeners
    this.refreshEventListeners();

    // Listen for checkout button click
    this.toCheckoutButton?.addEventListener(
      "click",
      this.handleToCheckoutPage.bind(this)
    );
  }

  // Periodically refresh event listeners
  refreshEventListeners() {
    console.log("Refreshing cart event listeners");

    // Find the latest remove and quantity buttons
    const removeButtons = this.querySelectorAll("[data-cart-remove]");
    const quantityInputs = this.querySelectorAll(".cart-item-qty-input");
    const quantityButtons = this.querySelectorAll(
      "[data-minus-quantity-cart], [data-plus-quantity-cart]"
    );

    // Set up direct event handlers for all cart interactions
    this.setupRemoveButtons(removeButtons);
    this.setupQuantityInputs(quantityInputs);
    this.setupQuantityButtons(quantityButtons);
  }

  // Set up iOS-specific styles
  setupIOSSpecificStyles() {
    // First, try to prevent any animations or transitions on cart elements
    const preventAnimationStyle = document.createElement("style");
    preventAnimationStyle.textContent = `
    /* Prevent animations on cart elements */
    .cart-item-qty,
    .cart-item-qty *,
    [data-minus-quantity-cart],
    [data-plus-quantity-cart],
    .cart-item-qty-input,
    .cart-remove {
      transition: none !important;
      animation: none !important;
      transform: none !important;
      animation-delay: 0s !important;
      animation-duration: 0s !important;
      transition-delay: 0s !important;
      transition-duration: 0s !important;
    }
  `;
    document.head.appendChild(preventAnimationStyle);

    // Wait a small amount of time to ensure the animation prevention takes effect
    setTimeout(() => {
      // Add iOS-specific styles with !important on everything
      const style = document.createElement("style");
      style.textContent = `
      /* iOS-specific fixes for cart - with higher specificity */
      html.ios .cart-item-qty,
      body.ios .cart-item-qty,
      html[class*="ios"] .cart-item-qty,
      [data-ios-cart] .cart-item-qty,
      .cart-item-qty {
        display: flex !important;
        flex-direction: row !important;
        align-items: center !important;
        justify-content: flex-start !important;
        width: auto !important;
        position: relative !important;
        flex-wrap: nowrap !important;
        margin: 0 !important;
        padding: 0 !important;
        transform: none !important;
        transition: none !important;
      }
      
      /* Fixed positions for each element */
      html.ios .cart-item-qty-input,
      body.ios .cart-item-qty-input,
      .cart-item-qty-input {
        order: 2 !important;
        position: static !important;
        margin: 0 10px !important;
        height: 38px !important;
        font-size: 16px !important;
        min-width: 40px !important;
        text-align: center !important;
        flex: 0 0 auto !important;
        transform: none !important;
      }
      
      html.ios [data-minus-quantity-cart],
      body.ios [data-minus-quantity-cart],
      [data-minus-quantity-cart] {
        order: 1 !important;
        position: static !important;
        display: inline-block !important;
        width: 30px !important;
        height: 30px !important;
        min-width: 30px !important;
        min-height: 30px !important;
        flex: 0 0 auto !important;
        padding: 0 !important;
        margin: 0 !important;
        text-align: center !important;
        line-height: 30px !important;
        transform: none !important;
      }
      
      html.ios [data-plus-quantity-cart],
      body.ios [data-plus-quantity-cart],
      [data-plus-quantity-cart] {
        order: 3 !important;
        position: static !important;
        display: inline-block !important;
        width: 30px !important;
        height: 30px !important;
        min-width: 30px !important;
        min-height: 30px !important;
        flex: 0 0 auto !important;
        padding: 0 !important;
        margin: 0 !important;
        text-align: center !important;
        line-height: 30px !important;
        transform: none !important;
      }
      
      /* Make remove button easier to tap */
      html.ios .cart-remove,
      body.ios .cart-remove,
      .cart-remove {
        width: 40px !important;
        height: 40px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        position: relative !important;
        z-index: 100 !important;
        transform: none !important;
      }
    `;
      document.head.appendChild(style);

      // Add iOS class to document for higher specificity
      document.documentElement.classList.add("ios");
      document.body.classList.add("ios");

      // Direct DOM manipulation to fix the layout - more aggressive approach
      if (typeof jQuery !== "undefined") {
        const $ = jQuery;

        // Find all cart item quantity containers
        $(".cart-item-qty").each(function () {
          const $container = $(this);

          // Add data attribute for CSS targeting
          $container.attr("data-ios-cart", "true");

          // Force the container to use flex layout
          $container.css({
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
            width: "auto",
            position: "relative",
            flexWrap: "nowrap",
            margin: "0",
            padding: "0",
            transform: "none",
            transition: "none",
          });

          // Get the elements
          const $minus = $container.find("[data-minus-quantity-cart]");
          const $input = $container.find(".cart-item-qty-input");
          const $plus = $container.find("[data-plus-quantity-cart]");

          // Apply direct styling to minus button
          $minus.css({
            order: "1",
            position: "static",
            display: "inline-block",
            width: "30px",
            height: "30px",
            minWidth: "30px",
            minHeight: "30px",
            flex: "0 0 auto",
            padding: "0",
            margin: "0",
            textAlign: "center",
            lineHeight: "30px",
            transform: "none",
          });

          // Apply direct styling to input
          $input.css({
            order: "2",
            position: "static",
            margin: "0 10px",
            height: "38px",
            fontSize: "16px",
            minWidth: "40px",
            textAlign: "center",
            flex: "0 0 auto",
            transform: "none",
          });

          // Apply direct styling to plus button
          $plus.css({
            order: "3",
            position: "static",
            display: "inline-block",
            width: "30px",
            height: "30px",
            minWidth: "30px",
            minHeight: "30px",
            flex: "0 0 auto",
            padding: "0",
            margin: "0",
            textAlign: "center",
            lineHeight: "30px",
            transform: "none",
          });

          // Only reorder if necessary
          if (
            $minus.index() > $input.index() ||
            $plus.index() < $input.index()
          ) {
            // Completely remove and recreate the container with correct order
            const container = $container[0];
            const parent = container.parentNode;

            // Create a new container
            const newContainer = document.createElement("div");
            newContainer.className = container.className;
            newContainer.setAttribute("data-ios-cart", "true");

            // Set inline styles
            newContainer.style.cssText =
              "display: flex !important; flex-direction: row !important; align-items: center !important; justify-content: flex-start !important; width: auto !important; position: relative !important; flex-wrap: nowrap !important;";

            // Append children in correct order
            newContainer.appendChild($minus[0].cloneNode(true));
            newContainer.appendChild($input[0].cloneNode(true));
            newContainer.appendChild($plus[0].cloneNode(true));

            // Replace original container
            parent.replaceChild(newContainer, container);

            // Re-add event listeners
            $(newContainer)
              .find("[data-minus-quantity-cart]")
              .on("click", function () {
                const input = $(this).siblings(".cart-item-qty-input")[0];
                const currentValue = parseInt(input.value, 10) || 0;
                input.value = Math.max(1, currentValue - 1);
                $(input).trigger("change");
              });

            $(newContainer)
              .find("[data-plus-quantity-cart]")
              .on("click", function () {
                const input = $(this).siblings(".cart-item-qty-input")[0];
                const currentValue = parseInt(input.value, 10) || 0;
                input.value = currentValue + 1;
                $(input).trigger("change");
              });
          }
        });
      }
    }, 200);

    console.log("Enhanced iOS-specific styles applied to cart elements");
  }

  // Set up remove buttons
  setupRemoveButtons(buttons) {
    if (!buttons || buttons.length === 0) return;

    buttons.forEach((button) => {
      // Skip if already processed
      if (button.hasAttribute("data-handler-attached")) return;

      // Mark as processed
      button.setAttribute("data-handler-attached", "true");

      // Remove existing handlers by cloning
      const parent = button.parentNode;
      if (!parent) return;

      const clone = button.cloneNode(true);
      parent.replaceChild(clone, button);
      button = clone;

      // Add special attributes for iOS
      if (this.isIOS) {
        button.setAttribute("role", "button");
        button.setAttribute("aria-label", "Remove item");
        button.setAttribute("tabindex", "0");
      }

      // Create a direct event handler
      const itemId = button.getAttribute("data-cart-remove-id");
      if (!itemId) return;

      // Create click handler
      const clickHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log("Remove button clicked for item:", itemId);

        // Show visual feedback
        const itemRow = button.closest("[data-item-row]");
        if (itemRow) {
          itemRow.style.opacity = "0.5";
          itemRow.style.pointerEvents = "none";
        }

        // Directly send fetch request to remove item
        this.removeCartItem(itemId);
      };

      // Add both click and touch events
      button.addEventListener("click", clickHandler);

      // For iOS, add touchend with capturing
      if (this.isIOS) {
        button.addEventListener(
          "touchend",
          (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log("iOS touchend on remove button");

            // Add slight delay for iOS
            setTimeout(() => {
              clickHandler(e);
            }, 10);
          },
          true
        ); // Use capturing phase
      }
    });
  }

  // Set up quantity inputs
  setupQuantityInputs(inputs) {
    if (!inputs || inputs.length === 0) return;

    inputs.forEach((input) => {
      // Skip if already processed
      if (input.hasAttribute("data-handler-attached")) return;

      // Mark as processed
      input.setAttribute("data-handler-attached", "true");

      // Add change event listener
      input.addEventListener("change", (e) => {
        const newValue = parseInt(e.target.value, 10) || 0;
        const itemId = input.getAttribute("data-cart-quantity-id");

        if (!itemId) return;

        // Update cart with new quantity
        this.updateCartItemQuantity(itemId, newValue);
      });
    });
  }

  // Set up quantity buttons
  setupQuantityButtons(buttons) {
    if (!buttons || buttons.length === 0) return;

    buttons.forEach((button) => {
      // Skip if already processed
      if (button.hasAttribute("data-handler-attached")) return;

      // Mark as processed
      button.setAttribute("data-handler-attached", "true");

      // Remove existing handlers by cloning
      const parent = button.parentNode;
      if (!parent) return;

      const clone = button.cloneNode(true);
      parent.replaceChild(clone, button);
      button = clone;

      // Add special attributes for iOS
      if (this.isIOS) {
        button.setAttribute("role", "button");
        button.setAttribute("tabindex", "0");
      }

      // Create click handler
      const clickHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Find the quantity input
        const container = button.closest(".cart-item-qty");
        if (!container) return;

        const input = container.querySelector(".quantity");
        if (!input) return;

        // Get current value and calculate new value
        const currentValue = parseInt(input.value, 10) || 0;
        let newValue = currentValue;

        if (button.hasAttribute("data-plus-quantity-cart")) {
          newValue = currentValue + 1;
        } else {
          newValue = Math.max(0, currentValue - 1);
        }

        // Update the input value
        input.value = newValue;

        // Find the item ID
        const itemId = input.getAttribute("data-cart-quantity-id");
        if (!itemId) return;

        // Update cart quantity
        this.updateCartItemQuantity(itemId, newValue);
      };

      // Add both click and touch events
      button.addEventListener("click", clickHandler);

      // For iOS, add touchend with capturing
      if (this.isIOS) {
        button.addEventListener(
          "touchend",
          (e) => {
            e.preventDefault();
            e.stopPropagation();

            // Add slight delay for iOS
            setTimeout(() => {
              clickHandler(e);
            }, 10);
          },
          true
        ); // Use capturing phase
      }
    });
  }

  // Remove item from cart
  removeCartItem(itemId) {
    console.log(`Removing item from cart: ${itemId}`);

    // Create the request body
    const body = JSON.stringify({
      id: itemId,
      quantity: 0,
    });

    // Send the request
    fetch(`${window.routes?.cart_change_url || "/cart/change"}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: body,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Refresh the page to show updated cart
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error removing item from cart:", error);
        // Alternative approach for iOS
        if (this.isIOS) {
          window.location.href = "/cart";
        }
      });
  }

  // Update item quantity
  updateCartItemQuantity(itemId, quantity) {
    console.log(`Updating cart item quantity: ${itemId} to ${quantity}`);

    // Create the request body
    const body = JSON.stringify({
      id: itemId,
      quantity: quantity,
    });

    // Send the request
    fetch(`${window.routes?.cart_change_url || "/cart/change"}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: body,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // If quantity is 0, refresh the page
        if (quantity === 0) {
          window.location.reload();
          return;
        }

        // Otherwise, update prices on the page
        this.updateCartDisplay(data);
      })
      .catch((error) => {
        console.error("Error updating cart quantity:", error);
        // Alternative approach for iOS
        if (this.isIOS) {
          window.location.href = "/cart";
        }
      });
  }

  // Update cart display after quantity changes
  updateCartDisplay(cartData) {
    if (!cartData) return;

    // Update item-specific values
    const items = cartData.items || [];

    items.forEach((item) => {
      const itemRow = document
        .querySelector(`[data-cart-remove-id="${item.id}"]`)
        ?.closest("[data-item-row]");
      if (!itemRow) return;

      // Update price display
      const priceElement = itemRow.querySelector(
        "[data-item-price-with-quantity-display]"
      );
      if (priceElement) {
        priceElement.innerHTML = this.formatMoney(item.final_line_price);
      }
    });

    // Update cart totals
    const subtotalElement = document.querySelector(
      ".cart-total-subtotal .cart-total-value .text"
    );
    if (subtotalElement) {
      subtotalElement.innerHTML = this.formatMoney(cartData.total_price);
    }

    const totalElement = document.querySelector(
      ".cart-total-grandtotal .cart-total-value .text"
    );
    if (totalElement) {
      totalElement.innerHTML = this.formatMoney(cartData.total_price);
    }
  }

  // Format money values
  formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    const value = parseInt(cents || 0, 10);
    const formatString =
      format ||
      window.money_format ||
      "<span class=money>€{{amount_with_comma_separator}}</span>";

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    let formattedMoney;

    if (formatString.indexOf("{{amount}}") > -1) {
      formattedMoney = formatString.replace(
        "{{amount}}",
        formatWithDelimiters(value, 2)
      );
    } else if (formatString.indexOf("{{amount_with_comma_separator}}") > -1) {
      formattedMoney = formatString.replace(
        "{{amount_with_comma_separator}}",
        formatWithDelimiters(value, 2, ".", ",")
      );
    } else if (formatString.indexOf("{{amount_no_decimals}}") > -1) {
      formattedMoney = formatString.replace(
        "{{amount_no_decimals}}",
        formatWithDelimiters(value, 0)
      );
    } else if (formatString.indexOf("{{amount_with_space_separator}}") > -1) {
      formattedMoney = formatString.replace(
        "{{amount_with_space_separator}}",
        formatWithDelimiters(value, 2, " ", ".")
      );
    }

    return formattedMoney;
  }

  initGiftCardElement() {
    const isChecked = this.giftCardButton?.dataset.isChecked;
    if (isChecked === "true") {
      const variantId = this.giftCardButton?.dataset.giftId;
      const giftCardRemoveButton = document.querySelector(
        `[data-cart-remove-id="${variantId}"]`
      );
      const giftCardQuantityInput = document.querySelector(
        `[data-cart-quantity-id="${variantId}"]`
      );

      this.giftCardElement.style.display = "none";
      giftCardRemoveButton?.addEventListener("click", () => {
        this.giftCardButton.dataset.isChecked = "false";
      });

      giftCardQuantityInput?.addEventListener("change", (e) => {
        const value = Number(e.target.value);
        if (value <= 0) {
          this.giftCardButton.dataset.isChecked = "false";
        }
      });
    } else {
      this.giftCardElement.style.display = "flex";
    }
  }

  initGiftCardManipulation() {
    if (this.giftCardButton) {
      this.giftCardButton.removeEventListener(
        "click",
        this.onAddGiftCardClick.bind(this)
      );
      this.giftCardButton.addEventListener(
        "click",
        this.onAddGiftCardClick.bind(this)
      );
    }
  }

  onAddGiftCardClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.giftCardButton.dataset.isChecked = "true";
  }

  initToCheckoutButtonDisabling() {
    if (this.checkTerms) {
      window.addEventListener("load", () => {
        this.toCheckoutButton.disabled = !this.checkTerms.checked;
      });
    }
  }

  async handleToCheckoutPage(e) {
    e.preventDefault();

    try {
      // saving coupon
      const couponCode = this.couponCodeInput?.value;
      if (couponCode) {
        localStorage.setItem("storedDiscount", couponCode);
        const couponRes = await fetch(`/discount/${couponCode}`);
        const text1 = await couponRes.text();
      }

      // saving cart note
      const cartNote = this.cartNoteInput?.value;
      if (cartNote) {
        const cartNoteBody = JSON.stringify({ note: cartNote });
        const cartNoteRes = await fetch(
          `${window.routes?.cart_update_url || "/cart/update"}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: cartNoteBody,
          }
        );
        const text2 = await cartNoteRes.text();
      }
    } catch (error) {
      console.error(`Error: ${error.message}`);
    }

    let checkoutHref = this.toCheckoutButton.dataset.href;
    if (checkoutHref == null) {
      checkoutHref = `${
        window.routes?.root ? window.routes.root : ""
      }/checkout`;
    }

    window.location = checkoutHref;
  }

  initCartCountdown() {
    if (!this.cartCountDown) return;

    if (!this.cartCountDown.classList.contains("is-running")) {
      const duration =
        this.cartCountDown.getAttribute("data-cart-countdown") * 60;
      const element = this.cartCountDown.querySelector(".time");

      this.cartCountDown.classList.add("is-running");
      this.startTimerCartCountdown(duration, element);
    }
  }

  startTimerCartCountdown(duration, element) {
    var timer = duration,
      minutes,
      seconds,
      text;

    var startCoundown = setInterval(() => {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      text = minutes + ":" + seconds;

      element.innerText = text;

      if (--timer < 0) {
        clearInterval(startCoundown);
        this.cartCountDown.remove();
      }
    }, 1000);
  }

  // Clean up when the element is removed
  disconnectedCallback() {
    // Clear the refresh interval
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }
}

// Add a script to handle Klaviyo popup interference
function handleKlaviyoPopup() {
  // Function to check if Klaviyo popup is active
  function isKlaviyoPopupActive() {
    return (
      document.querySelector('.needsclick[style*="z-index: 90000"]') !== null
    );
  }

  // Function to make cart elements higher z-index than Klaviyo
  function raiseCartElementsZIndex() {
    const cartRemoveButtons = document.querySelectorAll(".cart-remove");
    const quantityButtons = document.querySelectorAll(
      "[data-minus-quantity-cart], [data-plus-quantity-cart]"
    );

    // Set z-index higher than Klaviyo
    [...cartRemoveButtons, ...quantityButtons].forEach((button) => {
      button.style.zIndex = "100001";
      button.style.position = "relative";
    });

    // Also make cart rows higher z-index
    const cartRows = document.querySelectorAll("[data-item-row]");
    cartRows.forEach((row) => {
      row.style.zIndex = "10000";
      row.style.position = "relative";
    });
  }

  // Check periodically for Klaviyo popup
  setInterval(() => {
    if (isKlaviyoPopupActive()) {
      raiseCartElementsZIndex();
    }
  }, 1000);

  // Also listen for any Klaviyo-related elements being added to the DOM
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          const node = mutation.addedNodes[i];
          if (
            node.classList &&
            (node.classList.contains("needsclick") ||
              node.querySelector(".needsclick"))
          ) {
            raiseCartElementsZIndex();
            break;
          }
        }
      }
    });
  });

  // Start observing changes to the body
  observer.observe(document.body, { childList: true, subtree: true });
}

// Initialize the Klaviyo handler
if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
  window.addEventListener("DOMContentLoaded", handleKlaviyoPopup);
}

// Register the custom element
customElements.define("cart-items", CartItems);
